import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

// project-imports
import LoginFormStencil from "./LoginFormStencil";
import { useUserContext } from "../../context/user_context";
import { isBlockedDomain, toggle_password } from "../../utils";
import SEO from "../../common/SEO";
import Layout from "../../common/Layout";
import BreadcrumbOne from "../../common/breadcrumb/BreadcrumbOne";
import { GoogleAnalyticsEnum, pageView, triggerFunction } from "../../utils/google-analytics";
import Spinner from '../spinner-component/SpinnerOne';

// Reading env variable start here
const INVALID_EMAIL_ERROR_MESSAGE = process.env.REACT_APP_INVALID_EMAIL_ERROR_MESSAGE;
const EMAIL_ERROR_MESSAGE = process.env.REACT_APP_EMAIL_ERROR_MESSAGE;
// Reading env variable end here

const ForgotPasswordForm = ({ hideHeader = false, onClose }) => {

    // React router hook initialization
    const navigate = useNavigate();

    // Extracting methods and variables from context
    const { handleFogotPass } = useUserContext();

    // Reading data from store
    const { isLoading, loginData } = useSelector((item) => item.user);

    // State variables
    const [stencilLoading, setStencilLoading] = useState(true);
    const [disableBtn, setDisableBtn] = useState(true);
    const [forgotPassData, setForgotPassData] = useState({
        email: null,
    });
    const [inputValidationErrors, setInputValidationErrors] = useState({
        emailError: true,
        emailErrorText: "",
    });

    setTimeout(() => {
        setStencilLoading(false);
    }, 1000);

    // Constant variables
    const patterns = {
        email:
            /^[a-zA-Z0-9!#$%&*+=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&*=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9]{2,}(?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/,
    };

    useEffect(() => {
        if (!inputValidationErrors.emailError) {
            setDisableBtn(false);
        } else {
            setDisableBtn(true);
        }
    }, [inputValidationErrors]);

    // Constant functions
    const handleChange = (e) => {
        try {
            let existingEnquiryForm = {};
            existingEnquiryForm = {
                ...forgotPassData,
                [e.target.name]: e.target.value,
            };
            setForgotPassData(existingEnquiryForm);
            validationInput(e);
        } catch (error) {
            console.log("99 : LoginForm : Error while changing input => ", error && JSON.stringify(error));
            throw error;
        }
    };

    const validationInput = (e) => {
        try {
            let validationState = {};
            switch (e.target.name) {
                case "email":
                    validationState = {
                        ...inputValidationErrors,
                        emailError: !patterns[e.target.name].test(e.target.value) || isBlockedDomain(e.target.value),
                        emailErrorText: !patterns[e.target.name].test(e.target.value) ? EMAIL_ERROR_MESSAGE : isBlockedDomain(e.target.value) ? INVALID_EMAIL_ERROR_MESSAGE : ""
                    };
                    setInputValidationErrors(validationState);
                    break;
                default:
                    break;
            }
        } catch (error) {
            console.log("126 : LoginForm : Error while adding input => ", error && JSON.stringify(error));
            throw error;
        }
    };

    const handleForgotPasswordForm = async () => {
        try {
            if (!disableBtn) {
                const body = { ...forgotPassData }
                const response = await handleFogotPass(body);
                triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LOGIN_SUBMIT_BUTTON);
                if (response) {
                    navigate('/login', { replace: true });
                }
            }
        } catch (error) {
            console.log("141: LoginForm : Error while signing in :", error && JSON.stringify(error));
        }
    };

    const forgotPassComponent = () => {
        return (
            <div className="login-form-box">
                <h3 className="text-center mb-0">Forgotten Password</h3>
                <p className="text-center mb-30">Please enter your email below to reset your password.</p>
                <form className="p-10">
                    <div className="login-form">
                        <div className="input-box mb--30">
                            <label className="mb-2">E-mail</label>
                            <input
                                type="email"
                                disabled={isLoading}
                                name="email"
                                pattern="^[a-zA-Z0-9!#$%&*+=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&*=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9]{2,}(?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$"
                                autoFocus
                                required
                                title="Please Enter Valid Email"
                                placeholder="Enter Your Email"
                                onChange={handleChange}
                            />
                            {Boolean(forgotPassData.email && inputValidationErrors.emailError) ? (
                                <div className="invalid-data">{inputValidationErrors?.emailErrorText}</div>
                            ) : <div></div>}
                        </div>

                        <button
                            disabled={disableBtn}
                            className={"rn-btn edu-btn w-100"}
                            type="button"
                            onClick={handleForgotPasswordForm}
                        >
                            <span>Continue</span>
                            <i className="icon-arrow-right-line-right"></i>
                        </button>
                        <div className="block text-center my-3">I have remember my password.<Link to={"/login"} className="fw-bold"> Log in</Link></div>
                    </div>
                </form>
            </div>
        );
    }

    return (
        <>
            {pageView(window.location.pathname, GoogleAnalyticsEnum.LSA_LOGIN_FORM_VIEWED)}
            <div>
                {hideHeader ? <div className="container checkout-page-style pt-3">{forgotPassComponent()}</div> :
                    <>
                        <SEO title="Longswitch Academy Forgot Password" url="https://longswitchacademy.com/forgot-password" />
                        {isLoading && <Spinner />}
                        <Layout searchDisable={true}>
                            <BreadcrumbOne
                                title="Forgot Password"
                                rootUrl="/"
                                parentUrl="Home"
                                currentUrl="Forgot Password"
                            />
                            <div className="login-register-page-wrapper edu-section-gapBottom pt-5 bg-color-white">
                                <div className="container checkout-page-style">
                                    <div className="row">
                                        <div className="col-lg-6 mx-auto">
                                            {stencilLoading ? <LoginFormStencil /> :
                                                forgotPassComponent()
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Layout>
                    </>
                }
            </div>
        </>
    );
};

export default ForgotPasswordForm;
